export default "__VITE_ASSET__D8Hj1m0K__"